import { isArrayEmpty } from './arraysUtils';

/**
 * @function
 * Bound two objects to have exactly the same properties.
 * Returns a new object with the intersection of properties of two objects.
 * @param {Object} o1
 * @param {Object} o2
 * @returns Object
 */
export function objectIntersection(o1, o2) {
  let clonedObject = { ...o1 };
  Object.keys(clonedObject).forEach(function(item) {
    if (!Object.prototype.hasOwnProperty.call(o2, item)) {
      delete clonedObject[item];
    }
  });

  return clonedObject;
}

// Sort object or dictionary
export function sortObject(obj) {
  return Object.keys(obj)
    .sort()
    .reduce((x, k) => {
      x[k] = obj[k];
      return x;
    }, {});
}

/**
 * Find values that are in list1 but not in list2 by object propery, or in set theory list1 - list2
 * @param {Array} list1 Array of objects, we are going to look the elements in this array not present in list2
 * @param {Array} list2 Array of objects, we are going to look the elements not present in this array
 * @param {string} byKey Property to look or filter
 * @returns Array
 */
export const findElementsNotInList = (list1, list2, byKey) => {
  // find items in list1 that are not in list2
  const itemsNotInList2 = list1.filter(item => !list2.some(obj => obj[byKey] === item[byKey]));

  if (!isArrayEmpty(itemsNotInList2)) return itemsNotInList2;

  // find all the packages in list1 that have isExtra = true
  const extraItemsInList1 = list1.filter(item => item.isExtra);
  // find all the items in extraItemsInList1 that are not in list2 comparing if the byKey property is equal and isExtra = true
  const extraItemsNotInList2 = extraItemsInList1.filter(
    item => !list2.some(obj => obj[byKey] === item[byKey] && obj.isExtra)
  );

  if (!isArrayEmpty(extraItemsNotInList2)) return extraItemsNotInList2;

  // find the packages in list1 that have quantity greater than the counter-part in list2 matching byKey and isExtra
  const extraItemsInList1WithQuantityGreaterThanList2 = list1.filter(
    item => item.quantity > list2.find(obj => obj[byKey] === item[byKey] && obj.isExtra)?.quantity
  );

  if (!isArrayEmpty(extraItemsInList1WithQuantityGreaterThanList2)) {
    return extraItemsInList1WithQuantityGreaterThanList2.map(item => ({
      ...item,
      quantity: item.quantity - list2.find(obj => obj[byKey] === item[byKey] && obj.isExtra)?.quantity
    }));
  }

  return [];
};
